document.addEventListener('DOMContentLoaded', function () {

    // 🍎 1. CAPTURA DE DADOS
    // O window.frutasData é gerado pelo Blade via @json($frutasParaJs)
    const frutasData = window.frutasData || {};

    // 🔍 2. SELETORES DO DOM
    const conteudo1 = document.querySelector('.conteudo1');
    const conteudo2 = document.querySelector('.conteudo2');
    const frutasItems = document.querySelectorAll('.fruta');
    const btnVoltar = document.querySelector('.btn-voltar');

    // Elementos Internos do Conteúdo 2
    const frutaNomeEl = document.getElementById('fruta-nome');
    const listaVariacoesEl = document.getElementById('lista-variacoes');
    const btnFale = document.getElementById('btn-fale');
    const btnSaibaMais = document.getElementById('btn-saiba-mais');
    const dropdownToggle = document.getElementById('navbarDropdownMenuLink');

    // Variável de controle
    let frutaSelecionada = null;

    // 🔄 3. FUNÇÃO: RENDERIZAR VARIAÇÕES
    function renderizarVariacoes(variacoes, corDestaque) {
        if (!listaVariacoesEl) return;

        if (!variacoes || variacoes.length === 0) {
            listaVariacoesEl.innerHTML = '<p class="text-muted p-3">Nenhuma variação disponível.</p>';
            return;
        }

        listaVariacoesEl.innerHTML = variacoes.map(v => `
            <div class="variacao col-lg-6" tabindex="0" role="button">
                <div class="variacao-info">
                        <a href="${v.link}" style="display: inline-block; text-decoration: none; margin-bottom: 27px;" class="d-flex justify-content-between align-items-center"">    
                            <span class="variacao-nome">${v.nome}</span>
                  
                            <div class="variacao-icon">
                                ${v.svg}
                            </div>
                        </a>
                </div>
                <span class="variacao-categoria" style="background-color: ${corDestaque}22; color: ${corDestaque}; border: 1px solid ${corDestaque}44">
                    ${v.tags}
                </span>
            </div>
        `).join('');
    }

    // 🔄 4. FUNÇÃO: MOSTRAR DETALHES (TROCA DE TELA)
    function mostrarDetalhesFruta(key) {
        console.log("Tentando abrir chave:", key);
        const fruta = frutasData[key];

        if (!fruta) {
            console.error("Dados não encontrados para:", key);
            return;
        }

        frutaSelecionada = key;

        // Preenchimento de dados
        if (frutaNomeEl) {
            frutaNomeEl.textContent = fruta.nome;
            frutaNomeEl.style.color = fruta.corDestaque;
        }

        renderizarVariacoes(fruta.variacoes, fruta.corDestaque);

        if (btnFale) btnFale.href = fruta.linkContato;
        if (btnSaibaMais) btnSaibaMais.href = fruta.linkSaibaMais;

        // --- Lógica de Transição Forçada ---
        if (conteudo1 && conteudo2) {
            // 1. Resetar Conteúdo 1
            conteudo1.classList.remove('active');
            conteudo1.classList.add('hidden');
            conteudo1.style.display = 'none';

            // 2. Limpar e Preparar Conteúdo 2
            // Removemos TUDO o que pode esconder o elemento
            conteudo2.classList.remove('hidden');
            conteudo2.style.display = 'block';

            // Forçamos o navegador a registrar a mudança de display antes de animar
            void conteudo2.offsetWidth;

            // 3. Ativar
            conteudo2.classList.add('active');

            console.log("Classes atuais do Conteudo 2:", conteudo2.className);
        }
    }

    // 🔙 FUNÇÃO ÚNICA: VOLTAR PARA LISTA
    function voltarParaLista() {
        if (conteudo1 && conteudo2) {
            // 1. Esconder Conteúdo 2 com transição suave
            conteudo2.classList.remove('active');
            conteudo2.classList.add('hidden'); // ✅ Garante que fique oculto via CSS

            // 2. Preparar e mostrar Conteúdo 1
            conteudo1.classList.remove('hidden'); // ✅ REMOVE a classe que esconde!
            conteudo1.style.display = 'block';

            // Força reflow para garantir que a mudança de display seja aplicada antes da animação
            void conteudo1.offsetWidth;

            conteudo1.classList.add('active');

            // 3. Limpar seleção
            frutaSelecionada = null;

            console.log("✅ Voltou para lista de frutas");
        }
    }

    // 🎯 6. EVENT LISTENERS: CLIQUE NAS FRUTAS
    frutasItems.forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation(); // Impede o fechamento do dropdown do Bootstrap
            const fruitKey = this.getAttribute('data-fruit');
            mostrarDetalhesFruta(fruitKey);
        });

        // Acessibilidade (Enter)
        item.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const fruitKey = this.getAttribute('data-fruit');
                mostrarDetalhesFruta(fruitKey);
            }
        });
    });

    // 🎯 7. EVENT LISTENER: BOTÃO VOLTAR
    if (btnVoltar) {
        btnVoltar.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            voltarParaLista();
        });
    }

    // 🎯 8. CONTROLE DO DROPDOWN (BOOTSTRAP)
    // Impede que o menu feche ao navegar entre as telas internas
    const dropdownMenu = document.querySelector('.dropdown-menu');
    if (dropdownMenu) {
        dropdownMenu.addEventListener('click', function (e) {
            // Se clicar nos botões de ação final, o menu pode fechar (opcional)
            const isClickFinal = e.target.closest('#btn-fale') || e.target.closest('#btn-saiba-mais');
            if (!isClickFinal) {
                e.stopPropagation();
            }
        });
    }

    // 🎯 9. RESETAR MENU AO FECHAR O DROPDOWN
    // Localiza o elemento pai do dropdown (geralmente uma li ou div com .dropdown)
    const dropdownElement = document.getElementById('navbarDropdownMenuLink').closest('.dropdown');

    if (dropdownElement) {
        // Evento disparado pelo Bootstrap SEMPRE que o menu termina de fechar
        dropdownElement.addEventListener('hidden.bs.dropdown', function () {
            console.log("Dropdown fechado: Resetando para o Conteúdo 1");

            if (conteudo1 && conteudo2) {
                // 1. Volta o Conteúdo 1 para o estado inicial
                conteudo1.style.display = 'block';
                conteudo1.classList.add('active');
                conteudo1.classList.remove('hidden');

                // 2. Garante que o Conteúdo 2 suma completamente
                conteudo2.style.display = 'none';
                conteudo2.classList.remove('active');
                conteudo2.classList.add('hidden');

                // 3. Limpa a seleção interna
                frutaSelecionada = null;
            }
        });
    }

    console.log('✅ Sistema de Frutas pronto. Chaves carregadas:', Object.keys(frutasData));

    // 🍊 10. MENU DE PRODUTOS DO RODAPÉ (painel deslizante, independente do header)
    const footerMenuContainer = document.querySelector('.produtos-menu-footer');
    const footerLista = document.querySelector('.footer-produtos-lista');
    const footerDetalhe = document.querySelector('.footer-produtos-detalhe');
    const footerVariacoesEl = document.getElementById('footer-lista-variacoes');
    const footerNomeEl = document.querySelector('.footer-fruta-nome-selecionada');
    const footerBtnVoltar = document.querySelector('.footer-btn-voltar');
    const footerFrutaItems = document.querySelectorAll('[data-footer-fruit]');

    function footerAtualizarPopper() {
        // O Bootstrap/Popper decide se abre pra cima ou pra baixo com base no
        // tamanho do menu NAQUELE momento. Como mudamos a altura depois (via JS),
        // é preciso forçar o Popper a recalcular, senão ele nunca reconsidera
        // e o menu fica cortado embaixo quando não há espaço na tela.
        const toggleEl = document.getElementById('dropdownMenu2');
        if (!toggleEl || typeof bootstrap === 'undefined' || !bootstrap.Dropdown) return;
        const instance = bootstrap.Dropdown.getInstance(toggleEl);
        if (instance && typeof instance.update === 'function') {
            instance.update();
        }
    }

    function footerAjustarAltura(painel) {
        if (!footerMenuContainer || !painel) return;
        // O container usa box-sizing: border-box, então a altura precisa incluir
        // o próprio padding dele (senão o último item fica cortado embaixo).
        const estilo = getComputedStyle(footerMenuContainer);
        const paddingVertical = parseFloat(estilo.paddingTop) + parseFloat(estilo.paddingBottom);
        footerMenuContainer.style.height = (painel.scrollHeight + paddingVertical) + 'px';
        footerAtualizarPopper();
    }

    if (footerMenuContainer && footerLista) {
        footerAjustarAltura(footerLista);

        // Estima quantas linhas o menu pode ter (lista de frutas x maior painel
        // de variedades) e a altura de cada linha lida direto do CSS real
        // (.dropdown-item), sem nenhum valor fixo "chutado". Assim, se o
        // cliente cadastrar mais produtos/variedades no CMS, ou o design
        // mudar o espaçamento, a conta se ajusta sozinha.
        const numCategorias = Object.keys(frutasData).length;
        const maiorPainelVariacoes = Object.keys(frutasData).reduce(function (max, key) {
            const n = (frutasData[key].variacoes || []).length;
            return n > max ? n : max;
        }, 0);

        const itemRef = footerMenuContainer.querySelector('.dropdown-item');
        const containerStyle = getComputedStyle(footerMenuContainer);
        const paddingContainer = parseFloat(containerStyle.paddingTop) + parseFloat(containerStyle.paddingBottom);
        let alturaMaximaNecessaria = footerLista.scrollHeight || 0;

        if (itemRef) {
            const itemStyle = getComputedStyle(itemRef);
            const linhaAltura = parseFloat(itemStyle.lineHeight) || parseFloat(itemStyle.fontSize) * 1.3;
            const itemPadding = parseFloat(itemStyle.paddingTop) + parseFloat(itemStyle.paddingBottom);
            const alturaPorLinha = linhaAltura + itemPadding;
            const alturaListaEstimada = numCategorias * alturaPorLinha;
            // +1 linha para o botão "voltar" do painel de detalhe
            const alturaDetalheEstimada = (maiorPainelVariacoes + 1) * alturaPorLinha;
            alturaMaximaNecessaria = Math.max(alturaMaximaNecessaria, alturaListaEstimada, alturaDetalheEstimada);
        }

        alturaMaximaNecessaria += paddingContainer;

        const footerDropdownToggle = footerMenuContainer.closest('.dropdown');
        const toggleBtn = document.getElementById('dropdownMenu2');
        // O Bootstrap decide "pra cima ou pra baixo" olhando a classe .dropup no
        // PAI DIRETO do botão (toggleBtn.parentNode), não no .dropdown externo
        // que engloba todo o menu-footer. Aplicar a classe no elemento errado
        // fazia o Popper sempre calcular a posição como se não houvesse .dropup.
        const dropupTarget = toggleBtn ? toggleBtn.parentNode : null;

        if (footerDropdownToggle && toggleBtn && dropupTarget) {
            footerDropdownToggle.addEventListener('show.bs.dropdown', function () {
                const rect = toggleBtn.getBoundingClientRect();
                const espacoAbaixo = window.innerHeight - rect.bottom;
                const espacoAcima = rect.top;
                const precisaAbrirParaCima = espacoAbaixo < alturaMaximaNecessaria && espacoAcima > espacoAbaixo;
                dropupTarget.classList.toggle('dropup', precisaAbrirParaCima);
            });

            // .dropdown-menu fica display:none até o Bootstrap abrir o dropdown.
            // 'show.bs.dropdown' dispara ANTES da troca de display (ainda mede 0),
            // por isso usamos 'shown.bs.dropdown' (depois que já está visível)
            // para ajustar a altura real e, se necessário, corrigir o Popper.
            footerDropdownToggle.addEventListener('shown.bs.dropdown', function () {
                footerAjustarAltura(footerLista.classList.contains('active') ? footerLista : footerDetalhe);
            });
        }
    }

    function footerMostrarVariedades(key) {
        const fruta = frutasData[key];
        if (!fruta || !footerLista || !footerDetalhe) return;

        if (footerNomeEl) footerNomeEl.textContent = fruta.nome;

        if (footerVariacoesEl) {
            footerVariacoesEl.innerHTML = (fruta.variacoes || []).map(v => `
                <li><a class="dropdown-item variedade-item" href="${v.link}">${v.nome}</a></li>
            `).join('');
        }

        // Torna o painel mensurável (sem exibi-lo ainda) para calcular a altura real
        footerDetalhe.classList.remove('hidden');
        footerAjustarAltura(footerDetalhe);

        footerLista.classList.remove('active');
        footerLista.classList.add('slide-out');
        footerDetalhe.classList.add('active');
    }

    function footerVoltarParaLista() {
        if (!footerLista || !footerDetalhe) return;
        footerAjustarAltura(footerLista);
        footerDetalhe.classList.remove('active');
        footerLista.classList.remove('slide-out');
        footerLista.classList.add('active');
        setTimeout(() => footerDetalhe.classList.add('hidden'), 300);
    }

    footerFrutaItems.forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            footerMostrarVariedades(this.getAttribute('data-footer-fruit'));
        });
        item.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                footerMostrarVariedades(this.getAttribute('data-footer-fruit'));
            }
        });
    });

    if (footerBtnVoltar) {
        footerBtnVoltar.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            footerVoltarParaLista();
        });
    }

    // 📌 11. HEADER FIXO NO MOBILE
    // Abaixo de 991px a barra vira `position: fixed` (ver header.scss). Duas
    // coisas dependem da altura real dela — que varia conforme a logo cadastrada
    // no CMS — e por isso ela é publicada na CSS var --altura-navbar:
    //   1. o espaço reservado no topo das páginas internas, onde a barra
    //      ocupava lugar no fluxo antes de virar fixa;
    //   2. o teto do menu aberto, pra ele rolar por dentro em vez de vazar
    //      pra fora da tela.
    const navbarEl = document.querySelector('header .navbar');
    const navbarCollapse = document.getElementById('navbarNav');
    const logoNavbar = navbarEl ? navbarEl.querySelector('.navbar-brand img') : null;

    function atualizarAlturaNavbar() {
        if (!navbarEl) return;
        // Com o menu aberto a barra mede a altura do painel inteiro, que não é
        // o valor que queremos — nesse caso mantemos a última medição válida.
        if (navbarCollapse && (navbarCollapse.classList.contains('show') || navbarCollapse.classList.contains('collapsing'))) return;
        // A logo é um <img> sem dimensão declarada: antes de carregar, a barra
        // mede bem menos que a altura final. Medir nesse momento faria a página
        // subir e voltar; melhor deixar o fallback do CSS valendo até o load.
        if (logoNavbar && !logoNavbar.complete) return;
        document.documentElement.style.setProperty('--altura-navbar', navbarEl.offsetHeight + 'px');
    }

    atualizarAlturaNavbar();
    window.addEventListener('load', atualizarAlturaNavbar);
    window.addEventListener('resize', atualizarAlturaNavbar);

    if (logoNavbar) {
        logoNavbar.addEventListener('load', atualizarAlturaNavbar);
    }

    if (navbarCollapse) {
        navbarCollapse.addEventListener('hidden.bs.collapse', atualizarAlturaNavbar);
    }

    // Fundo da barra: transparente sobre o banner da home, sólido a partir do
    // momento em que existe conteúdo passando por baixo dela. O CSS só usa a
    // classe no mobile, então no desktop isso não tem efeito visual.
    function atualizarFundoNavbar() {
        if (!navbarEl) return;
        navbarEl.classList.toggle('scrolled', window.scrollY > 10);
    }

    atualizarFundoNavbar();
    window.addEventListener('scroll', atualizarFundoNavbar, { passive: true });

    const footerDropdownMenu = document.querySelector('.produtos-menu-footer');
    if (footerDropdownMenu) {
        footerDropdownMenu.addEventListener('click', function (e) {
            e.stopPropagation();
        });

        const footerDropdownParent = footerDropdownMenu.closest('.dropdown');
        if (footerDropdownParent) {
            footerDropdownParent.addEventListener('hidden.bs.dropdown', function () {
                if (footerLista && footerDetalhe) {
                    footerDetalhe.classList.remove('active');
                    footerDetalhe.classList.add('hidden');
                    footerLista.classList.remove('slide-out');
                    footerLista.classList.add('active');
                    footerAjustarAltura(footerLista);
                }
            });
        }
    }
});